import { Purchase } from '@domain'
import {
	DirectDeal,
	DirectDealCategory,
	DirectDealsOverview,
	DirectDealStatus,
	DirectDealSummary,
} from '@services/directDeals.types'

export const directDealsOverview: DirectDealsOverview = {
	total: 5,
	accepted: 2,
	pending: 2,
	rejected: 1,
	acceptedAnnualTotalSavings: 14520.5,
}

export const mockPurchase: Purchase = {
	groupKey: '99313, 7053565, 177261215',
	groupKeyDisplayName: 'Davios (PA)',
	qtyPurchased: 24,
	totalPrice: 1260.24,
	pricePerCase: 52.51,
	caseVolume: 1260.24,
	annualVolume: 4521.5062,
	customerLocationDmid: 99313,
	customerName: 'Fake Customer Location',
	customerParentDmid: 385484,
	customerParentName: 'Fake Customer Parent',
	distributorProductDmid: '7053565',
	distributorLocationDmid: 198398,
	distributorLocationName: 'Fake Distributor Location',
	distributorParentDmid: 600001,
	distributorParentName: 'Fake Distributor Parent',
	dpc: 'NC888B',
	manufacturerProductDmid: 188943,
	manufacturerName: 'Acme Corp',
	manufacturerPlid: 'MA-9999901',
	mpc: 'NC888B',
	brandName: 'FakeBrand',
	brandType: 'Manufacturer',
	packSize: '1/150 CT',
	description: 'FAKE PRODUCT 8X8 CONTAINER',
	totalWeight: 0,
	derivedCost: 0,
	directDeal: '',
	marginMarkup: '',
	marketSegment: 'Healthcare',
	type: 'SIMILAR_MATCH',
	hasSimilarProducts: true,
	currentProgramType: 'DIRECT',
	matchedProduct: {
		type: 'EXACT_MATCH',
		adjustedDeviatedCost: 38.5,
		annualContractSavings: 234.0,
		annualPriceSavings: 1571.45,
		annualRebate: 120.0,
		annualTotalSavings: 1691.45,
		annualVolume: 1200,
		brand: 'FakeMatchBrand',
		brandOwner: 'Manufacturer',
		calculationSummary: null,
		caseVolume: 480.0,
		category: 'Paper Products',
		dateRangeContractSavings: 58.5,
		dateRangeRebateSavings: 30.0,
		dateRangeTotalSavings: 88.5,
		description: 'FAKE MATCHED PRODUCT 8X8',
		deviatedCost: 38.5,
		deviatedPrice: null,
		distributorLocationName: 'Fake Distributor Location',
		distributorParentName: 'Fake Distributor Parent',
		distributorProductDmid: 100002,
		dpc: '999002',
		estimatedFob: null,
		exclusionSource: null,
		extendedPrice: null,
		manufacturerName: 'Acme Corp',
		manufacturerPlid: 'MA-9999901',
		manufacturerProductDmid: 200002,
		markupAmount: null,
		markupDescription: null,
		markupFromOppy: 8,
		markupAmountFromOppy: 3.08,
		markupTypeFromOppy: 'Percent Markup',
		mpc: 'FAKE-MPC-002',
		packPurchaseQty: null,
		packSimilarQty: null,
		packSize: '4/50 CT',
		packSizeConversion: 1,
		packCvtModified: true,
		perCasePrice: 41.58,
		perCaseRebate: 0.5,
		perCaseSavings: 4.41,
		qty: 26,
		rebatesSummary: null,
		rebateTermSetName: 'Acme Corp Rebate Tier 1',
		savingsPercentage: 9.6,
		savingsTermSetName: 'Acme Corp Savings Tier 1',
		score: 0.95,
		sellPrice: 41.58,
		sellPriceOverride: null,
		stocked: true,
		totalSellPrice: 41.58,
		unit: 'FULL',
	},
}

export const directDealSummaries: DirectDealSummary[] = [
	{
		id: 12,
		marketBasketId: 2338,
		manufacturerPlid: 'MA-9999901',
		manufacturerName: 'Imaginal Disk',
		customerPlid: 'CL-0000001',
		customerName: 'Magdalena Bay',
		coverage: 100,
		stocking: 76.92,
		annualTotalSavings: 2262.74,
		annualRebateSavings: 691.28,
		annualPriceSavings: 1571.45,
		annualSavingsPercent: 8.64,
		exactCoverage: 98.5,
		exactAnnualPriceSavings: 1559.12,
		exactAnnualRebateSavings: 689.4,
		exactAnnualTotalSavings: 2248.52,
		category: DirectDealCategory.DECLINE,
		status: DirectDealStatus.ACCEPTED,
	},
	{
		id: 13,
		marketBasketId: 2338,
		manufacturerPlid: 'MA-9999902',
		manufacturerName: 'Fanfare',
		customerPlid: 'CL-0000002',
		customerName: 'Advantage Lucy',
		coverage: 85,
		stocking: 92,
		annualTotalSavings: 5430.12,
		annualRebateSavings: 2100.0,
		annualPriceSavings: 3330.12,
		annualSavingsPercent: 12.45,
		exactCoverage: 84.2,
		exactAnnualPriceSavings: 3318.07,
		exactAnnualRebateSavings: 2095.5,
		exactAnnualTotalSavings: 5413.57,
		category: DirectDealCategory.RECOMMEND,
		status: DirectDealStatus.ACCEPTED,
	},
	{
		id: 14,
		marketBasketId: 2338,
		manufacturerPlid: 'MA-9999903',
		manufacturerName: 'Only God Was Above Us',
		customerPlid: 'CL-0000003',
		customerName: 'Vampire Weekend',
		coverage: 67,
		stocking: 55,
		annualTotalSavings: 890.0,
		annualRebateSavings: 340.0,
		annualPriceSavings: 550.0,
		annualSavingsPercent: 4.2,
		exactCoverage: 66.3,
		exactAnnualPriceSavings: 544.75,
		exactAnnualRebateSavings: 338.1,
		exactAnnualTotalSavings: 882.85,
		category: DirectDealCategory.RECOMMEND,
		status: DirectDealStatus.PENDING,
	},
]

export const directDeals: DirectDeal[] = directDealSummaries.map((summary) => ({
	summary,
	purchases: [mockPurchase],
	purchaseCounts: { total: 1, stocked: 1, notStocked: 0 },
}))
